const IT_LOCALE = {
  code: 'it',
  name: 'Italiano',
  translations: {
    zoom: {
      in: 'Ingrandisci',
      out: 'Riduci',
      Menu: 'Menu zoom',
      menu: 'Menu zoom',
      level: 'Livello di zoom ({level}%)',
      fitPage: 'Adatta alla pagina',
      fitWidth: 'Adatta alla larghezza',
      marquee: 'Selezione area'
    },
    commands: {
      zoom: {
        in: 'Ingrandisci',
        out: 'Riduci',
        fitWidth: 'Adatta alla larghezza',
        fitPage: 'Adatta alla pagina',
        automatic: 'Automatico',
        level: 'Livello di zoom ({level}%)',
        inArea: 'Ingrandisci area'
      },
      fullscreen: {
        enter: 'Schermo intero',
        exit: 'Esci da schermo intero'
      },
      rotate: {
        clockwise: 'Ruota in senso orario',
        counterclockwise: 'Ruota in senso antiorario'
      },
      menu: 'Menu',
      sidebar: 'Barra laterale',
      search: 'Cerca',
      comment: 'Commento',
      download: 'Scarica',
      print: 'Stampa',
      openFile: 'Apri PDF',
      save: 'Salva',
      settings: 'Impostazioni',
      view: 'Vista',
      annotate: 'Annota',
      shapes: 'Forme',
      redact: 'Redigi',
      fillAndSign: 'Compila e firma',
      form: 'Modulo',
      pan: 'Panoramica',
      pointer: 'Puntatore',
      undo: 'Annulla',
      redo: 'Ripristina',
      copy: 'Copia',
      screenshot: 'Screenshot',
      nextPage: 'Pagina successiva',
      previousPage: 'Pagina precedente'
    },
    document: {
      open: 'Apri documento',
      print: 'Stampa',
      export: 'Esporta',
      fullscreen: 'Schermo intero',
      loading: 'Caricamento...'
    },
    page: {
      next: 'Pagina successiva',
      previous: 'Pagina precedente',
      settings: 'Impostazioni pagina',
      spreadMode: 'Modalità',
      single: 'Pagina singola',
      twoOdd: 'Doppia dispari',
      twoEven: 'Doppia pari',
      scrollLayout: 'Scorrimento',
      vertical: 'Verticale',
      horizontal: 'Orizzontale',
      rotation: 'Rotazione'
    },
    rotate: {
      clockwise: 'Ruota a destra',
      counterClockwise: 'Ruota a sinistra'
    },
    mode: {
      view: 'Vista',
      annotate: 'Annota',
      shapes: 'Forme'
    },
    annotation: {
      addLink: 'Aggiungi link',
      deleteSelected: 'Elimina selezione',
      comment: 'Commento',
      style: 'Stile',
      styles: 'Stili',
      moreTools: 'Altri strumenti',
      defaults: 'Predefiniti',
      highlight: 'Evidenzia',
      strikeout: 'Barrato',
      underline: 'Sottolinea',
      squiggly: 'Sottolinea ondulata',
      ink: 'Disegna',
      text: 'Testo',
      selectAnnotation: 'Seleziona annotazione',
      stamp: 'Timbro',
      Stamp: 'Timbro',
      strokeColor: 'Colore tratto',
      opacity: 'Opacità',
      strokeWidth: 'Spessore tratto',
      blendMode: 'Modalità di fusione'
    },
    link: {
      title: 'Titolo',
      url: 'URL',
      page: 'Pagina',
      enterUrl: 'Inserisci URL',
      link: 'Link',
      enterPage: 'Inserisci pagina',
      pageRange: 'Intervallo pagine'
    },
    common: {
      cancel: 'Annulla'
    },
    comments: {
      page: 'Pagina',
      commentCount: 'Numero commenti',
      addComent: 'Aggiungi commento',
      edit: 'Modifica',
      delete: 'Elimina',
      addReply: 'Aggiungi risposta'
    },
    blendMode: {
      normal: 'Normale',
      multiply: 'Moltiplica',
      screen: 'Schermo',
      overlay: 'Sovrapponi',
      darken: 'Scurisci',
      lighten: 'Schiarisci',
      colorDodge: 'Schermo colore',
      colorBurn: 'Brucia colore',
      hardLight: 'Luce intensa',
      softLight: 'Luce soffusa',
      difference: 'Differenza',
      exclusion: 'Esclusione',
      hue: 'Tonalità',
      saturation: 'Saturazione',
      color: 'Colore',
      luminosity: 'Luminosità'
    },
    history: {
      undo: 'Annulla',
      redo: 'Ripristina'
    },
    pan: {
      toggle: 'Panoramica'
    },
    pointer: {
      toggle: 'Puntatore'
    },
    capture: {
      screenshot: 'Schermata'
    },
    panel: {
      sidebar: 'Pannello',
      search: 'Cerca',
      annotationStyle: 'Stile annotazione'
    },
    menu: {
      viewControls: 'Controlli vista',
      zoomControls: 'Controlli zoom'
    },
    search: {
      placeholder: 'Cerca',
      caseSensitive: 'Maiuscole',
      wholeWord: 'Parola intera'
        ,resultsFound: 'Risultati trovati: {count}'
    },
    selection: {
      copy: 'Copia'
    }
  }
}

const PT_LOCALE = {
  code: 'pt',
  name: 'Português',
  translations: {
    zoom: {
      in: 'Ampliar',
      out: 'Reduzir',
      Menu: 'Menu de zoom',
      menu: 'Menu de zoom',
      level: 'Nível de zoom ({level}%)',
      fitPage: 'Ajustar a página',
      fitWidth: 'Ajustar a largura',
      marquee: 'Seleção de área'
    },
    commands: {
      zoom: {
        in: 'Ampliar',
        out: 'Reduzir',
        fitWidth: 'Ajustar a largura',
        fitPage: 'Ajustar a página',
        automatic: 'Automático',
        level: 'Nível de zoom ({level}%)',
        inArea: 'Ampliar área'
      },
      fullscreen: {
        enter: 'Tela cheia',
        exit: 'Sair da tela cheia'
      },
      rotate: {
        clockwise: 'Girar no sentido horário',
        counterclockwise: 'Girar no sentido anti-horário'
      },
      menu: 'Menu',
      sidebar: 'Barra lateral',
      search: 'Pesquisar',
      comment: 'Comentário',
      download: 'Transferir',
      print: 'Imprimir',
      openFile: 'Abrir PDF',
      save: 'Guardar',
      settings: 'Configurações',
      view: 'Ver',
      annotate: 'Anotar',
      shapes: 'Formas',
      redact: 'Redigir',
      fillAndSign: 'Preencher e assinar',
      form: 'Formulário',
      pan: 'Arrastar',
      pointer: 'Ponteiro',
      undo: 'Desfazer',
      redo: 'Refazer',
      copy: 'Copiar',
      screenshot: 'Captura de ecrã',
      nextPage: 'Página seguinte',
      previousPage: 'Página anterior'
    },
    document: {
      open: 'Abrir documento',
      print: 'Imprimir',
      export: 'Exportar',
      fullscreen: 'Tela cheia',
      loading: 'A carregar...'
    },
    page: {
      next: 'Página seguinte',
      previous: 'Página anterior',
      settings: 'Definições de página',
      spreadMode: 'Modo de página',
      single: 'Página única',
      twoOdd: 'Dupla ímpar',
      twoEven: 'Dupla par',
      scrollLayout: 'Rolagem',
      vertical: 'Vertical',
      horizontal: 'Horizontal',
      rotation: 'Rotação'
    },
    rotate: {
      clockwise: 'Girar à direita',
      counterClockwise: 'Girar à esquerda'
    },
    mode: {
      view: 'Ver',
      annotate: 'Anotar',
      shapes: 'Formas'
    },
    annotation: {
      addLink: 'Adicionar link',
      deleteSelected: 'Eliminar seleção',
      comment: 'Comentário',
      style: 'Estilo',
      styles: 'Estilos',
      moreTools: 'Mais ferramentas',
      defaults: 'Predefinicoes',
      highlight: 'Realcar',
      strikeout: 'Tachado',
      underline: 'Sublinhado',
      squiggly: 'Sublinhado ondulado',
      ink: 'Desenhar',
      text: 'Texto',
      selectAnnotation: 'Selecionar anotacao',
      stamp: 'Carimbo',
      Stamp: 'Carimbo',
      strokeColor: 'Cor do traço',
      opacity: 'Opacidade',
      strokeWidth: 'Espessura do traço',
      blendMode: 'Modo de mistura'
    },
    link: {
      title: 'Título',
      url: 'URL',
      page: 'Página',
      enterUrl: 'Introduza o URL',
      link: 'Link',
      enterPage: 'Introduza a página',
      pageRange: 'Intervalo de páginas'
    },
    common: {
      cancel: 'Cancelar'
    },
    comments: {
      page: 'Página',
      commentCount: 'Número de comentários',
      addComent: 'Adicionar comentário',
      edit: 'Editar',
      delete: 'Eliminar',
      addReply: 'Adicionar resposta'
    },
    blendMode: {
      normal: 'Normal',
      multiply: 'Multiplicar',
      screen: 'Ecrã',
      overlay: 'Sobrepor',
      darken: 'Escurecer',
      lighten: 'Clarear',
      colorDodge: 'Sobreexposição de cor',
      colorBurn: 'Subexposição de cor',
      hardLight: 'Luz forte',
      softLight: 'Luz suave',
      difference: 'Diferença',
      exclusion: 'Exclusão',
      hue: 'Matiz',
      saturation: 'Saturação',
      color: 'Cor',
      luminosity: 'Luminosidade'
    },
    history: {
      undo: 'Desfazer',
      redo: 'Refazer'
    },
    pan: {
      toggle: 'Arrastar'
    },
    pointer: {
      toggle: 'Ponteiro'
    },
    capture: {
      screenshot: 'Captura'
    },
    panel: {
      sidebar: 'Painel',
      search: 'Pesquisar',
      annotationStyle: 'Estilo de anotação'
    },
    menu: {
      viewControls: 'Controles de visualização',
      zoomControls: 'Controles de zoom'
    },
    search: {
      placeholder: 'Pesquisar',
      caseSensitive: 'Maiúsculas',
      wholeWord: 'Palavra inteira'
        ,resultsFound: 'Resultados encontrados: {count}'
    },
    selection: {
      copy: 'Copiar'
    }
  }
}

export const EMBEDPDF_LOCALES = [IT_LOCALE, PT_LOCALE]

export function getEmbedPdfLocale (locale) {
  const value = (locale || 'en').toLowerCase()
  if (value.startsWith('es')) return 'es'
  if (value.startsWith('it')) return 'it'
  if (value.startsWith('pt')) return 'pt'
  return 'en'
}

export function getEmbedPdfI18nConfig (locale) {
  const normalized = getEmbedPdfLocale(locale)
  const config = {
    defaultLocale: normalized,
    fallbackLocale: 'es'
  }
  if (normalized === 'it' || normalized === 'pt') {
    config.locales = EMBEDPDF_LOCALES
  }
  return config
}
